import React, { useEffect, useState } from 'react';
import ErrorMessage from '../../../../shared/FormComponents/ErrorMessage/ErrorMessage';
import { Controller } from 'react-hook-form';
import Dropdown from "../../../../shared/FormComponents/CustomDropdown/CustomDropdown";
import { CountryModel } from '../../../../../common/model/CountryModel';
import DIContainer from '../../../../../config/di.container';
import OnBoardingLookupService from '../../../../../services/OnboardingService';
import DITYPES from '../../../../../config/di.types';
import { AUPhoneRegex, characterRegex, EmailRegex, PhoneRegex, USPhoneRegex } from '../../../../../common/constant';
import LocalStorageService from '../../../../../services/local.storage.service';


export interface IBillingDetailsProps {
    register: any;
    errors: any;
    onChangeHandler: any;
    control: any;
    setValue: any;
    trigger: any;
}

const onboardingLookupService = DIContainer.get<OnBoardingLookupService>(DITYPES.OnboardingLookupService);
const localStorageService = DIContainer.get<LocalStorageService>(DITYPES.LocalstorageService);

const BillingDetails: React.FC<IBillingDetailsProps> = (props) => {

    const [countries, setCountries] = useState<CountryModel[]>();
    const [stateLoader, setLoader] = useState(false);
    const [phoneCode, setPhoneCode] = useState<any>('');
    const [provinces, setStateProvinces] = useState<any[]>();
    const [phoneNumber, setPhoneNumber] = useState<any>('');
    const [isUSPhoneFormat, setUSPhoneFormat] = useState<boolean>(true);

    let billingDetailsForm: any = {
        billingAddress: {
            Label: "Billing address",
            FieldName: "billingAddress1",
            ValidationAndEvent: { required: true, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        billingCountry: {
            Label: "Country",
            FieldName: "billingCountry",
            ValidationAndEvent: { required: true, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        billingProvince: {
            Label: "State/Province",
            FieldName: "billingStateProv",
            ValidationAndEvent: { required: true, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        billingPostalCode: {
            Label: "Postal code",
            FieldName: "billingPostalCode",
            ValidationAndEvent: { required: true, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        billingCity: {
            Label: "City",
            FieldName: "billingCity",
            ValidationAndEvent: { required: true, pattern: characterRegex, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        billingPhoneNumber: {
            Label: "Phone number",
            FieldName: "billingPhone",
            ValidationAndEvent: { required: true, pattern: PhoneRegex, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        billingEmail: {
            Label: "Email address",
            FieldName: "billingEmail",
            ValidationAndEvent: { required: true, pattern: EmailRegex, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        }
    }

    const [formState, setFormState] = useState<any>(billingDetailsForm);

    useEffect(() => {
        window.scrollTo(0, 0);
        (async () => {
            loadActivateLaunchForm();

        })();
    }, [])

    //This is used to trigger the Phone number validation when formState is changed//
    useEffect(() => {
        if (phoneNumber) {
            props.trigger("billingPhone");
        }
    }, [formState])

    const loadActivateLaunchForm = async () => {
        if (!countries) {
            await getValuesFromService();
        }
    }

    const getValuesFromService = async () => {
        let countries = await onboardingLookupService.getCountries();
        setCountries(countries);
    }

    const getRegexByCountryCode = (value: any) => {
        switch (value) {
            case "US":
                return USPhoneRegex;
            case "AU":
                return AUPhoneRegex;
            default:
                return PhoneRegex;
        }
    };

    const onDropdownChangeHandler = async (value: any) => {
        let phone = "";
        setUSPhoneFormat(value == "US");

        billingDetailsForm.billingPhoneNumber = {
            FieldName: "billingPhone", Label: "Phone number", ValidationAndEvent: {
                required: true, pattern: getRegexByCountryCode(value), onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) }
            }
        }

        setFormState(billingDetailsForm);

        if (value == "US" && phoneNumber) {
            phone = getUSFormattedNumber(phoneNumber);
        }
        else {
            phone = phoneNumber?.replace(/[^0-9.]/g, "");
        }
        setPhoneNumber(phone);

        let countryCode = value.trim();
        var selectedCountry = countries?.filter(x => x.Code == countryCode)[0];
        setPhoneCode(`+${selectedCountry?.PhoneCode} `);
        props.setValue("billingPhone", `+${selectedCountry?.PhoneCode} ${phone}`);

        setLoader(true);
        let response = await onboardingLookupService.getStates(countryCode);
        setLoader(false);
        setStateProvinces(response?.States);


    }

    const getUSFormattedNumber = (phoneNumber: string): string => {
        let phoneNo = "";
        const input = phoneNumber?.replace(/\D/g, '');
        const zip = input.substring(0, 3);
        const middle = input.substring(3, 6);
        const last = input.substring(6, 10);

        if (input.length > 6) {
            phoneNo = `(${zip}) ${middle} - ${last}`;
        }
        else if (input.length > 3) {
            phoneNo = `(${zip}) ${middle}`;
        }
        else if (input.length > 0) {
            phoneNo = `(${zip}`;
        }

        return phoneNo;
    }

    const onPhoneNumberChangeHandler = (event) => {
        var phoneNo = event.target.value.substring(phoneCode.length, event.target.value.length);

        if (isUSPhoneFormat) {
            phoneNo = getUSFormattedNumber(phoneNo);
        }
        else {
            phoneNo = phoneNo.replace(/[^0-9.]/g, "");
        }

        setPhoneNumber(phoneNo);
        props.setValue("billingPhone", `${phoneCode}${phoneNo}`);
        props.trigger("billingPhone");
    }

    return (
        <div>
            <div className="request-live-acc-text">Billing Contact Information</div>
            <div className="request-live-text">Enter your information below to set up an API billing account. You will receive email notifications every time Mindbody charges your account.</div>
            {billingDetailsForm.billingAddress && props &&
                <div className="padding-top-32">
                    <label className="activate-launch-label">{billingDetailsForm.billingAddress.Label}*</label>
                    <textarea {...props?.register(billingDetailsForm.billingAddress.FieldName, billingDetailsForm.billingAddress.ValidationAndEvent)}
                        id="request-live-bill-addr" autoComplete="disabled" className="activate-launch-description-text-area" ></textarea>
                    <ErrorMessage errors={props.errors} {...billingDetailsForm.billingAddress}></ErrorMessage>
                </div>
            }
            <div className="d-flex justify-content-between">
                {
                    <div className="padding-top-32 w-50">
                        <div className="wd-100">
                            <label className="request-live-label">{billingDetailsForm.billingCity.Label}*</label>
                            <input {...props?.register(billingDetailsForm.billingCity.FieldName, billingDetailsForm.billingCity.ValidationAndEvent)}
                                maxLength={255} autoComplete="disabled" className="last-name-input" type="text" id="ob-bill-city"
                            >
                            </input>
                            <ErrorMessage errors={props.errors} {...billingDetailsForm.billingCity} message={"is not valid."}></ErrorMessage>
                        </div>
                    </div>
                }
                {
                    <div className="padding-top-32 w-50">
                        <div className="last-name-container">
                            <label className="activate-launch-label">{billingDetailsForm.billingPostalCode.Label}*</label>
                            <input {...props?.register(billingDetailsForm.billingPostalCode.FieldName, billingDetailsForm.billingPostalCode.ValidationAndEvent)}
                                maxLength={50} autoComplete="disabled" className="first-name-input" type="text" id="ob-bill-postalcode"
                            >
                            </input>
                            <ErrorMessage errors={props.errors} {...billingDetailsForm.billingPostalCode} message={"is not valid."}></ErrorMessage>
                        </div>
                    </div>
                }
            </div>
            <div className="d-flex justify-content-between">
                {
                    <div className="padding-top-32 wd-50">
                        <div className="inte-dr-div inte-dr-div-left">
                            {/* @ts-ignore */}
                            <Controller
                                control={props.control}
                                name="billingCountry"
                                rules={{ required: true }}
                                render={(
                                    { field: { onChange, value, ref, ...field },
                                        fieldState: { invalid }
                                    }) => (
                                    <Dropdown
                                        {...field}
                                        data={countries}
                                        id="BillingCountry"
                                        value={value}
                                        changeFunc={(value) => onChange(value, onDropdownChangeHandler(value))}
                                        label={`${billingDetailsForm.billingCountry.Label}*`}
                                        controlId="languageControlId"
                                        isCheckMark
                                        error={invalid}
                                        valueField="Code"
                                        labelField="CountryName"
                                        classNameLabel="activate-launch-label"
                                    />
                                )}
                            />
                        </div>
                    </div>
                }
                {
                    <div className="padding-top-32 int-typ-drop wd-50">
                        <div className="inte-dr-div">
                            {/* @ts-ignore */}
                            <Controller
                                control={props.control}
                                name="billingStateProv"
                                rules={{ required: true }}
                                render={({ field: { onChange, onBlur, value, ref },
                                    fieldState: { invalid, isTouched, isDirty, error }
                                }) => (
                                    <Dropdown className="lang-drop"
                                        data={provinces}
                                        id="province"
                                        value={value}
                                        changeFunc={onChange}
                                        label={`${billingDetailsForm.billingProvince.Label}*`}
                                        controlId="requestLiveData"
                                        isCheckMark
                                        error={invalid}
                                        valueField="Code"
                                        labelField="Name"
                                        classNameLabel="activate-launch-label"
                                        placeholder={stateLoader ? "Loading" : "Select"}
                                    />
                                )}
                            />
                        </div>
                    </div>
                }
            </div>
            <div className="d-flex">
                {
                    <div className="padding-top-32 w-50">
                        <div className="wd-100">
                            <label className="activate-launch-label">{formState.billingPhoneNumber.Label}*</label>
                            <input {...props?.register(formState.billingPhoneNumber.FieldName, formState.billingPhoneNumber.ValidationAndEvent)}
                                maxLength={255} autoComplete="disabled" className="first-name-input" type="text" id="ob-bill-phone" value={`${phoneCode}${phoneNumber}`}
                                onChange={onPhoneNumberChangeHandler}
                            >
                            </input>
                            <ErrorMessage errors={props.errors} {...formState.billingPhoneNumber} message={"is not valid."}></ErrorMessage>
                        </div>
                    </div>
                }
                {
                    <div className="padding-top-32 w-50">
                        <div className="last-name-container">
                            <label className="activate-launch-label">{billingDetailsForm.billingEmail.Label}*</label>
                            <input {...props?.register(billingDetailsForm.billingEmail.FieldName, billingDetailsForm.billingEmail.ValidationAndEvent)}
                                maxLength={50} autoComplete="disabled" className="last-name-input" type="text" id="ob-bill-email"
                            >
                            </input>
                            <div className="activate-launch-note-text">This email address will be used for billing communications.</div>
                            <ErrorMessage errors={props.errors} {...billingDetailsForm.billingEmail} message={"is not valid."}></ErrorMessage>
                        </div>
                    </div>
                }
            </div>
        </div>
    )

}

export default BillingDetails;